import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/forms/LoginForm';
import { ROUTES } from '../constants/constants';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const navigate = useNavigate();
  const {
    login,
    passwordLogin,
    verifyOTP,
    resendOTP,
    verifyEmailOtp,
    resendEmailOtp,
  } = useAuth();

  // Navigate only when tokens are actually issued — the 2FA stage-1
  // response returns success without tokens.
  const navigateIfLoggedIn = (response) => {
    if (response?.success && response?.data?.tokens) {
      navigate(ROUTES.DASHBOARD, { replace: true });
    }
  };

  const handlePasswordLogin = async (identifier, password, rememberMe) => {
    const response = await passwordLogin(identifier, password, rememberMe);
    navigateIfLoggedIn(response);
    return response;
  };

  const handleRequestOtp = async (mobile) => {
    return login(mobile);
  };

  const handleVerifyOtp = async (mobile, otp) => {
    const response = await verifyOTP(mobile, otp);
    navigateIfLoggedIn(response);
    return response;
  };

  const handleResendOtp = async (mobile) => {
    return resendOTP(mobile);
  };

  // 2FA step 2 — consume OTP, navigate on success.
  const handleVerifyEmailOtp = async (identifier, otp) => {
    const response = await verifyEmailOtp(identifier, otp);
    navigateIfLoggedIn(response);
    return response;
  };

  const handleResendEmailOtp = async (identifier) => {
    return resendEmailOtp(identifier);
  };

  return (
    <LoginForm
      onPasswordLogin={handlePasswordLogin}
      onRequestOtp={handleRequestOtp}
      onVerifyOtp={handleVerifyOtp}
      onResendOtp={handleResendOtp}
      onVerifyEmailOtp={handleVerifyEmailOtp}
      onResendEmailOtp={handleResendEmailOtp}
    />
  );
}
